import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { AppService } from "src/app/app.service";

@Component({
  selector: 'app-resources-links',
  templateUrl: './resources-links.component.html',
  styleUrls: ['./resources-links.component.scss']
})
export class ResourcesLinksComponent implements OnInit {
  @Input() resourcesList: any;
  @Input() assetName: any;
  accessCodePresent: boolean = false;
  mailText: string;

  constructor(private _appService: AppService) { }

  ngOnInit(): void {
    (this.resourcesList['access_code'] == null || this.resourcesList['access_code'] == "Not Filled" || this.resourcesList['access_code'] == "") ? this.accessCodePresent = false : this.accessCodePresent = true;
  }

  accessCode() {
    if(this.resourcesList['codeaccessmechanism'][0].id == 1)
        this._appService.downloadCodeRepo(this.resourcesList['access_code']).subscribe(blob => {
         saveAs(blob, this.resourcesList['access_code_filename'])
    });
    // else
    //     window.open("//"+this.resourcesList['access_code'])
  }

  resourceCode(i: any) {
    // console.log(i)
    // console.log(this.resourcesList);
    
        this._appService.downloadCodeRepo(i.Link).subscribe(blob => {
         saveAs(blob, i.File)
    });
  }


}
